<template>
  <div :class="{ 'switch-container': true, 'switch-on': switchOn, 'switch-off': !switchOn }" @click="toggleSwitch">
    <div :class="{ 'switch': true, 'on': switchOn, 'off': !switchOn }"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  data() {
    return {
      switchOn: this.value
    };
  },
  methods: {
    toggleSwitch() {
      this.switchOn = !this.switchOn;
      this.$emit('input', this.switchOn);
    }
  }
};
</script>

<style>
.switch-container {
  width: 60px;
  height: 30px;
  background-color: #ccc;
  border-radius: 15px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}
.switch-container.switch-on {
  background-color: #00a0b2;
}
.switch-container.switch-off {
  background-color: #ccc;
}
.switch {
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: 5px;
  transition: transform 0.3s;
}
.on {
  transform: translateX(30px);
}
.off {
  transform: translateX(0);
}

</style>



// WEBPACK FOOTER //
// src/components/utils/SwitchOnOff.vue